import Sidebar from "../Components/Sidebar";
import Navbar from "../Components/Navbar";
import { Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../Contexts/AuthContext";
import { useState, useEffect } from "react";
import SecurityWrapper from "../Components/SecurityWrapper";
import "./MainLayout.css";

export default function MainLayout() {
  const { isAuthenticated, loading, user } = useAuth();
  const navigate = useNavigate();

  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(() => {
    return localStorage.getItem("dis_sidebar_collapsed") === "true";
  });
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleSidebar = () => {
    const nextState = !isSidebarCollapsed;
    setIsSidebarCollapsed(nextState);
    localStorage.setItem("dis_sidebar_collapsed", String(nextState));
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen((prev) => !prev);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const isOrgAdmin = user?.user_type === 'admin' || user?.rbac_roles_details?.some(r => r.is_org_admin);
  const isExemptFromEmployeeOnboarding = user?.is_superuser || user?.is_staff || isOrgAdmin;

  useEffect(() => {
    if (!loading && !isAuthenticated) {
      navigate("/");
    } else if (!loading && isAuthenticated && user) {
      if (user.must_change_password) {
        navigate("/change-password");
      } else if (user.user_type === 'agency') {
        navigate("/agency-portal");
      } else if (isOrgAdmin && !user.onboarding_completed) {
        navigate("/onboarding");
      } else if (!isExemptFromEmployeeOnboarding && !user.onboarding_completed && user.onboarding_required) {
        navigate("/employee-onboarding");
      }
    }
  }, [isAuthenticated, loading, navigate, user, isOrgAdmin, isExemptFromEmployeeOnboarding]);

  const shouldBlockLayout = user && (user.must_change_password || (!user.onboarding_completed && (
    (isOrgAdmin) || (!isExemptFromEmployeeOnboarding && user.onboarding_required)
  )));

  if (loading || !isAuthenticated || shouldBlockLayout) {
    return <div style={{ background: '#0d0d0d', minHeight: '100vh' }} />;
  }

  return (
    <div className={`main-layout-container ${isSidebarCollapsed ? "sidebar-collapsed" : ""}`}>
      <Sidebar
        isCollapsed={isSidebarCollapsed}
        onToggle={toggleSidebar}
        isMobileOpen={isMobileMenuOpen}
        onCloseMobile={closeMobileMenu}
      />

      <div className="main-content-wrapper">
        <Navbar
          isMobileOpen={isMobileMenuOpen}
          onToggleMobileMenu={toggleMobileMenu}
        />
        <div className="content-padding">
          <SecurityWrapper>
            <Outlet />
          </SecurityWrapper>
        </div>
      </div>
    </div>
  );
}